export default __webpack_public_path__ + "static/media/incompletesequence.b7df7540.svg";